import React, {useState, useRef, useCallback, useEffect} from "react";

const SliderSection = ({loading, imageData, getimageData, Modal}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const touchEndX = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);

  const [newImageData, setNewImageData] = useState();
  const previousImage = () => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
  };

  const nextImage = () => {
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
  };

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === "ArrowLeft") {
  //       previousImage();
  //     } else if (event.key === "ArrowRight") {
  //       nextImage();
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [currentImageIndex]);
  const handleTouchStart = (event) => {
    setTouchStartX(event.touches[0].clientX);
  };

  const handleTouchMove = (event) => {
    touchEndX.current = event.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const touchDistance = touchEndX.current - touchStartX;
    if (touchDistance > 0 && touchDistance > window.innerWidth * 0.3) {
      getimageData(imageData?.data?.prevLink);
    } else if (touchDistance < 0 && -touchDistance > window.innerWidth * 0.3) {
      getimageData(imageData?.data?.nextLink);
    }
  };

  useEffect(() => {
    let nData = imageData?.data?.imageData;
    let imageAttach = parseInt(nData?.attach_type);
    let aTypeUrl = "";
    if (imageAttach == 3) {
      aTypeUrl =
        "https://media.bookeventz.com/884x350/html/bookeventz.com/images/banquet-layout/" +
        nData?.image_name;
    } else if (imageAttach == 1) {
      aTypeUrl =
        "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-picture/" +
        nData?.image_name;
    } else if (imageAttach == 2) {
      aTypeUrl =
        "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-award/" +
        nData?.image_name;
    } else if (imageAttach == 13) {
      aTypeUrl =
        "https://media.bookeventz.com/html/bookeventz.com/images/albums/" + nData?.image_name;
    } else if (imageAttach == 7) {
      aTypeUrl =
        "https://media.bookeventz.com/441x272/html/bookeventz.com/images/artist/portfolio/" +
        nData?.image_name;
    } else if (imageAttach == 6) {
      aTypeUrl =
        "https://media.bookeventz.com/441x272/html/bookeventz.com/images/artist/logo/" +
        nData?.image_name;
    }
    setNewImageData(nData);
    setImageUrl(aTypeUrl);
  }, [imageData]);

  useEffect(() => {
    if (!loading) {
      const handleKeyDown = (event) => {
        if (event.key === "ArrowLeft") {
          getimageData(imageData?.data?.prevLink);
        } else if (event.key === "ArrowRight") {
          getimageData(imageData?.data?.nextLink);
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [loading, imageData]);
  

  return (
    <>
      {loading ? (
        <div id="loader-67">
          <img src="../../media/Pino.svg" alt="Loading image" />
        </div>
      ) : (
        <div
          className="slider-new-page"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <span id="cross-origin" onClick={() => Modal(false)}>
            <img
              src="../../media/ArrowCross.svg"
              alt="Cancel icon to close gallery"
              id="cancel-g-btn"
            />
          </span>
          <img
            src="../../media/prev.svg"
            alt="previous button"
            id="prev-i"
            style={{cursor: "pointer"}}
            onClick={() => getimageData(imageData?.data?.prevLink)}
          />
          <div id="image-page-wrapper">
            <img
              src={imageUrl}
              alt={newImageData?.RestaurantName !== null && newImageData?.RestaurantName}
            />
          </div>
          <img
            src="../../media/next.svg"
            alt="previous button"
            style={{cursor: "pointer"}}
            id="nex-i"
            onClick={() => getimageData(imageData?.data?.nextLink)}
          />
        </div>
      )}
    </>
  );
};

export default SliderSection;
